import { render, staticRenderFns } from "./OnboardingSummary.vue?vue&type=template&id=4b5cf7d0&"
import script from "./OnboardingSummary.vue?vue&type=script&lang=ts&"
export * from "./OnboardingSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports